import { useSuspenseQuery } from '@tanstack/react-query';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { getMonthlyUsage } from '../api/detailsUsageApi';
import { mapMonthlyUsageDTOtoBarChartData } from 'src/common/utils/mapMonthlyUsageDTOtoBarChartData';
import { detailsQueries } from '../queries/detailsQueries';
import { DetailsTypeValue } from '../UsageChartsSection';
import { useTranslation } from 'react-i18next';

type UseDetailsMonthlyUsageDataProps = {
  id: string;
  usageType: UsageTypeValue;
  detailsType: DetailsTypeValue;
};

export const useDetailsMonthlyUsageData = ({
  id,
  usageType,
  detailsType,
}: UseDetailsMonthlyUsageDataProps) => {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getMonthlyUsage>>,
    Error,
    ReturnType<typeof mapMonthlyUsageDTOtoBarChartData>
  >({
    queryKey: detailsQueries.monthlyUsage({ id, usageType, detailsType }),
    queryFn: () => setMinimalPromiseTime(getMonthlyUsage({ id, usageType, detailsType })),
    select: (chartData) => mapMonthlyUsageDTOtoBarChartData(chartData, usageType, t),
  });

  return data;
};
